<template>
  <div class="item-main">
    <div class="title">
      Trend Chart
    </div>
    <div
      class="form"
      :style="{
        'flex-direction': !isDesktop && 'column',
        'align-items': !isDesktop && 'start',
      }"
    >
      <ActivitySelector
        v-model:value="query.activityId"
        @change="getData"
      ></ActivitySelector>
      <DateRangePicker
        @change="onDateChange"
        :style="{
          'margin-top': !isDesktop && '8px',
        }"
      ></DateRangePicker>
    </div>
    <a-spin :spinning="spinning">
      <LineChart
        v-if="query.activityId"
        :YMDDateList="YMDDateList"
        :xData="xData"
        :chartData="chartData"
      ></LineChart>
      <div v-else class="default-chart">
        <img src="../../../assets/statistics/line_chart_default.svg" alt="" />
      </div>
    </a-spin>
  </div>
</template>

<script>
import ActivitySelector from '@/components/ActivitySelector'
import DateRangePicker from '@/components/DateRangePicker'
import LineChart from './LineChart'

export default {
  name: 'TrendChart1',
  components: { ActivitySelector, DateRangePicker, LineChart },
  mounted() {
    const id = this.$store.state.link.defaultActivityId
    if (id) {
      this.query.activityId = id
      this.getData()
    }
  },
  computed: {
    defaultActivityId() {
      return this.$store.state.link.defaultActivityId
    },
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  watch: {
    defaultActivityId() {
      this.query.activityId = this.defaultActivityId
      this.getData()
    },
  },
  data() {
    return {
      query: {
        activityId: undefined,
        createTimeBegin: undefined,
        createTimeEnd: undefined,
      },
      YMDDateList: undefined,
      xData: undefined,
      chartData: undefined,
      spinning: false,
    }
  },
  methods: {
    getData() {
      if (!this.query.activityId) return
      this.spinning = !this.spinning
      this.$store
        .dispatch('statistics/GetTrendChart1', this.query)
        .then((res) => {
          this.chartData = res
        })
        .finally(() => {
          this.spinning = !this.spinning
        })
    },
    onDateChange(beginTime, endTime, YMDDateList, MDDateList) {
      this.query.createTimeBegin = beginTime
      this.query.createTimeEnd = endTime
      this.YMDDateList = YMDDateList
      this.xData = MDDateList
      this.getData()
    },
  },
}
</script>

<style lang="scss">
.item-main {
  padding: 20px;

  .title {
    font-size: 20px;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
  }

  .form {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }

  .default-chart {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 20px;
  }
}
</style>
